import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";

import Footer from "./Footer";
import SMCLogo from "./SMCLogo";

import styles from "./Layout.module.css";
import commonStyles from "./common.module.css";
import "./global.css";
import { FormattedMessage } from "react-intl";

const root =
  process.env.CI_COMMIT_REF_NAME &&
  process.env.CI_COMMIT_REF_NAME !== "production"
    ? `/${process.env.CI_COMMIT_REF_NAME}`
    : "/";

const Layout = ({ currentURL, langKey, children }) => {
  const {
    site: { siteMetadata },
  } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          title
          shortTitle
        }
      }
    }
  `);

  return (
    <>
      <div className={styles.wrapper}>
        <header className={styles.header}>
          <Link to={root} className={styles.headerLink}>
            <SMCLogo width={134} height={36} />
            <span className={styles.title}>{siteMetadata.shortTitle}</span>
          </Link>
          <div className={styles.grow} />
        </header>

        <main className={commonStyles.container}>{children}</main>
      </div>

      <Footer currentURL={currentURL} langKey={langKey} />
    </>
  );
};

export default Layout;
